import { Material, MeshStandardMaterial, Mesh, BoxGeometry, BufferGeometry, Texture } from "three";
import { Main } from "../../../Main";

export interface ILeanToPostConfig
{
	material?: Material;
}

export class LeanToPost
{
	private _config: ILeanToPostConfig;

	private _mesh: Mesh;
	private static _geom: BufferGeometry;

	constructor(config?: ILeanToPostConfig)
	{
		this._config = config;
		this.init();
	}

	private init()
	{
		// or:
		// var mesh = AddonManager.getInstance().createMesh("Support Post");

		var geometry = LeanToPost.getGeometry();

		var configMaterial = this._config && this._config.material;

		var material: Material = configMaterial;
		if (!material)
		{
			var materialColor = Main.getInstance().config.colorCollection.getByKey("rustic_red").hex as string;

			var meshMaterial = new MeshStandardMaterial({
				roughness: 1,
				metalness: 0,
				color: materialColor,
				envMap: Main.getInstance().content.scene3D.background as Texture,
			});

			material = meshMaterial;
		}

		this._mesh = new Mesh(geometry, material);
		this._mesh.name = `leantopost`;
		this._mesh.castShadow = true;
	}

	public static getGeometry(): BufferGeometry
	{
		if (!LeanToPost._geom)
		{
			LeanToPost._geom = new BoxGeometry();
		}
		return LeanToPost._geom;
	}
	public get container(): Mesh
	{
		return this._mesh;
	}
}